import React, { useState } from 'react'
import { Box, Typography, Skeleton, Divider } from '@mui/material'
import { useNavigate, useParams, Outlet } from 'react-router-dom'

// Local Imports
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import RequestAttachment from 'module/leave/pages/requestDetails/components/requestAttachment'
import RequestButtonOptions from 'module/leave/pages/leaveCreditDetails/components/requestButtonOptions'
import leaveRequestStatusHandler from 'module/leave/util/leaveRequestStatusHandler'

// API services
import { useShowLeaveRequest } from 'services/api/modules/leave/leaveRequest'
import CreditApproval from '../components/creditApproval'

const LeaveCreditDetails = ({ state }) => {
  const { backgroundLocation } = state
  const navigate = useNavigate()
  const params = useParams()
  const [drawerState, setDrawerState] = useState({ right: true })

  const { data: item, isLoading } = useShowLeaveRequest(params.id)
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
    navigate(-1)
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return ''
    const [year, month, day] = dateStr.split('-')
    console.log(dateStr)

    return `${day}/${month}/${year}`
  }

  const Header = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          width: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        {isLoading ? (
          <Skeleton width="200px" />
        ) : (
          <>
            <Typography variant="h4" color="dark-text.main">
              {item?.duration === 1
                ? `${item?.duration} day leave`
                : `${item?.duration} days leave`}
            </Typography>
            <AdxStatusBar sx={{ px: 2 }} status={leaveRequestStatusHandler(item?.status)} />
          </>
        )}
      </Box>
    )
  }

  const handleSubmitDocument = () => {
    navigate(`/app/leave/leave_credit/${item.id}/submitDocument`, {
      state: {
        backgroundLocation: backgroundLocation,
        item: item,
      },
    })
  }

  return (
    <>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        sx={{ p: 0 }}
        headerprops={<Header />}
        footerprops={
          <RequestButtonOptions
            requestStatus={item?.status}
            handleSubmit={handleSubmitDocument}
            updatedAt={item?.updated_at}
          />
        }
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: 2,
          }}
        >
          <Box
            display={'flex'}
            flexDirection={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'flex-start', lg: 'center' }}
          >
            <Typography
              variant="body1"
              color="light-gray-text.main"
              sx={{ width: { xs: '100%', lg: '25%' } }}
            >
              Type
            </Typography>
            {isLoading ? (
              <Box width={'100%'}>
                <Skeleton width={'100%'} />
              </Box>
            ) : (
              <Typography
                variant="body1"
                color="dark-gray-text.main"
                sx={{ width: { xs: '100%', lg: '75%' } }}
              >
                Leave Credit Request
              </Typography>
            )}
          </Box>
          <Box
            display={'flex'}
            flexDirection={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'flex-start', lg: 'center' }}
          >
            <Typography
              variant="body1"
              color="light-gray-text.main"
              sx={{ width: { xs: '100%', lg: '25%' } }}
            >
              Start Date
            </Typography>
            {isLoading ? (
              <Box width={'100%'}>
                <Skeleton width={'100%'} />
              </Box>
            ) : (
              <Typography
                variant="body1"
                color="dark-gray-text.main"
                sx={{ width: { xs: '100%', lg: '75%' } }}
              >
                {formatDate(item?.start_date)}
              </Typography>
            )}
          </Box>
          <Box
            display={'flex'}
            flexDirection={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'flex-start', lg: 'center' }}
          >
            <Typography
              variant="body1"
              color="light-gray-text.main"
              sx={{ width: { xs: '100%', lg: '25%' } }}
            >
              End Date
            </Typography>
            {isLoading ? (
              <Box width={'100%'}>
                <Skeleton width={'100%'} />
              </Box>
            ) : (
              <Typography
                variant="body1"
                color="dark-gray-text.main"
                sx={{ width: { xs: '100%', lg: '75%' } }}
              >
                {formatDate(item?.end_date)}
              </Typography>
            )}
          </Box>
          <Box
            display={'flex'}
            flexDirection={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'flex-start', lg: 'center' }}
          >
            <Typography
              variant="body1"
              color="light-gray-text.main"
              sx={{ width: { xs: '100%', lg: '25%' } }}
            >
              Reason
            </Typography>
            {isLoading ? (
              <Box width={'100%'}>
                <Skeleton width={'100%'} height={50} />
              </Box>
            ) : (
              <Typography
                variant="body1"
                color="dark-gray-text.main"
                sx={{ width: { xs: '100%', lg: '75%' } }}
              >
                {item?.reason}
              </Typography>
            )}
          </Box>
          {item?.attachment ? (
            isLoading ? (
              <>
                <Box>
                  <Skeleton width={'100%'} height={100} />
                </Box>
              </>
            ) : (
              <Box my={2}>
                <RequestAttachment item={item} />
              </Box>
            )
          ) : null}
          <Box display={'flex'} flexDirection={'column'}>
            <Typography variant="body1" color="light-gray-text.main">
              Progress
            </Typography>
            {isLoading ? (
              <>
                <Box>
                  <Skeleton width={'100%'} height={100} />
                </Box>
              </>
            ) : (
              <Box sx={{ mt: 1.25 }}>
                <CreditApproval approvalArr={item?.leave_approval} requestItem={item} />
              </Box>
            )}
          </Box>
          {/* <Box sx={{ mt: 2 }}>
            <RequestButtonOptions
              requestStatus={item?.status}
              handleSubmit={handleSubmitDocument}
              updatedAt={item?.updated_at}
            />
          </Box> */}
        </Box>
      </AdxDrawerComponent>
      <Outlet />
    </>
  )
}

export default LeaveCreditDetails
